// extracted by mini-css-extract-plugin
module.exports = {"EmptyResultCards":"EmptyResultCards_EmptyResultCards__3ZkGV"};